export default __webpack_public_path__ + "static/media/mask-shapes-left.0e546563.png";